import { RequestParams, RequestResponse, requestJson, setCookie } from '@vfde-sails/utils';
import { call } from 'redux-saga/effects';
import { Endpoints } from '../../enum';
import { AdditionalPageOptions, JarvisRequest, JarvisResponse } from 'app/interface';
import { getUrl } from '../../util/url';
import { VF_DOMAIN } from '../../constants';
import { getCMSConfig } from '../../util/cms';

export function* getJarvisData () {


    const { gigaTvMetaCode }: AdditionalPageOptions = yield call(getCMSConfig);

    const url: string = yield call(getUrl, VF_DOMAIN, Endpoints.JARVIS);
    const body: JarvisRequest = {
        ids: [ gigaTvMetaCode ],
    };
    const options: RequestParams = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': 'KSZZFe5MPWBLc3cLUPs2zW5at1w7xQyg',
        },
        body: yield call(JSON.stringify, body),
    };

    const response: RequestResponse<JarvisResponse> = yield call(requestJson, url, options);

    return response.body?.products[0];
}
